import { render } from "./ReportsAnalytics.vue?vue&type=template&id=61074944"
import script from "./ReportsAnalytics.vue?vue&type=script&lang=js"
export * from "./ReportsAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__